module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter",
    attrs: {
      "id": "toc"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "hanging1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781429983969_epub_ack_r1.htm"
    }
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781429983969_epub_itr_r1.htm"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781429983969_epub_p01_r1.htm"
    }
  }, [_c('strong', [_vm._v("PART I: PREPARING YOUR 90/10 KITCHEN")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781429983969_epub_c01_r1.htm"
    }
  }, [_c('strong', [_vm._v("1")]), _vm._v("  90/10 Success!")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781429983969_epub_c02_r1.htm"
    }
  }, [_c('strong', [_vm._v("2")]), _vm._v("  Shopping Smart")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781429983969_epub_c03_r1.htm"
    }
  }, [_c('strong', [_vm._v("3")]), _vm._v("  Cooking ABC’s")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781429983969_epub_p02_r1.htm"
    }
  }, [_c('strong', [_vm._v("PART II: COOKING WITH JOY!")])])]), _vm._v(" "), _c('p', {
    staticClass: "hanging1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781429983969_epub_c04_r1.htm"
    }
  }, [_c('strong', [_vm._v("4")]), _vm._v("  Breakfast: Recipes to Break the Fast")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781429983969_epub_c05_r1.htm"
    }
  }, [_c('strong', [_vm._v("5")]), _vm._v("  Lunch: Our Midday Motivator")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781429983969_epub_c06_r1.htm"
    }
  }, [_c('strong', [_vm._v("6")]), _vm._v("  Dinner Is Served")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781429983969_epub_c07_r1.htm"
    }
  }, [_c('strong', [_vm._v("7")]), _vm._v("  Gourmet Dinners and Festive Holiday Menus")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781429983969_epub_c08_r1.htm"
    }
  }, [_c('strong', [_vm._v("8")]), _vm._v("  Kids in the Kitchen")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781429983969_epub_c09_r1.htm"
    }
  }, [_c('strong', [_vm._v("9")]), _vm._v("  90/10 Fun Food Favorites!")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging2"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781429983969_epub_c10_r1.htm"
    }
  }, [_c('strong', [_vm._v("10")]), _vm._v("  Mixing It Up: The Fourteen-Day Menu Plan (plus The Vegetarian Diet Plan)")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/9781429983969_epub_ind_r1.htm"
    }
  }, [_vm._v("Index")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0527bcc4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/9781429983969_epub_toc_r1.vue
// module id = 72
// module chunks = 0